import React, {useMemo} from 'react'
import ActionUiHandler from '@ui/template/actionUiHandler/ActionUiHandler'
import NotFound from '@ui/notFound/NotFound'
import {useAppContext} from '@context/appContext/hooks/useAppContext'
import {SxType} from '@baseTypes/sx/sxTypes'
import {
	useGetCameraPhotoStatsQuery,
	useGetCameraPreviewsQuery,
	useGetCameraSnapshotDevicesQuery
} from '@containers/monitoringPlatform/photoFixation/queryHooks/useCameraSnapshotsQuery'
import {PhotoFixationList} from '@containers/monitoringPlatform/photoFixation/list/PhotoFixationList'
import {mergeCameraSnapshots} from '@containers/monitoringPlatform/photoFixation/helpers/mergeCameraSnapshots'

const sx: SxType = {
	height: '100%',
}

const PhotoFixationByAccount = () => {
	const {account} = useAppContext()

	const {
		data: devices,
		isLoading,
		isFetching,
	} = useGetCameraSnapshotDevicesQuery(account.id)

	const {data: stats, isLoading: isStatsLoading} = useGetCameraPhotoStatsQuery(account.id)
	const {data: previews, isLoading: isPreviewsLoading} = useGetCameraPreviewsQuery(account.id)

	const snapshots = useMemo(
		() => mergeCameraSnapshots(devices, stats, previews),
		[devices, stats, previews]
	)

	return (
		<ActionUiHandler
			isLoading={isFetching}
			isLoadingWithoutRender={isLoading}
			sx={sx}
		>
			{!devices?.length && !isLoading && !isFetching && <NotFound/>}

			<PhotoFixationList
				snapshots={snapshots}
				accountId={account.id}
				isStatsLoading={isStatsLoading}
				isPreviewsLoading={isPreviewsLoading}
			/>
		</ActionUiHandler>
	)
}

export default PhotoFixationByAccount
